import { motion } from "framer-motion";
import { POD_PHASES } from "../../data/content";

export const PodArchitecture = () => (
  <section id="pod-architecture" className="py-20 md:py-28 bg-white" data-testid="pod-architecture-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <p className="text-xs md:text-sm tracking-[0.25em] uppercase text-[#D4AF37] font-semibold">How It Works</p>
      <h2 className="mt-4 font-serif text-3xl md:text-4xl lg:text-5xl text-[#0B1B2B] tracking-tight max-w-3xl">
        The 3-Phase Clinical Pod Model
      </h2>
      <p className="mt-5 text-[#64748B] leading-relaxed text-sm md:text-base max-w-3xl">
        Every student pod moves through the same three phases, so preceptors and host facilities always know
        exactly what a student can and can't do at each stage.
      </p>
      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
        {POD_PHASES.map((p, idx) => (
          <motion.div
            key={p.phase}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: idx * 0.1 }}
            className="bg-[#F8FAFC] border border-[#E2E8F0] rounded-xl p-7"
            data-testid={`pod-phase-${idx + 1}`}
          >
            <span className="inline-flex w-9 h-9 rounded-full bg-[#0B1B2B] text-[#D4AF37] font-serif font-bold items-center justify-center text-sm">
              {idx + 1}
            </span>
            <div className="mt-4 text-[10px] font-bold tracking-[0.18em] uppercase text-[#94A3B8]">{p.phase}</div>
            <h3 className="mt-1.5 font-serif text-xl text-[#0B1B2B] font-semibold">{p.title}</h3>
            <p className="mt-3 text-sm text-[#64748B] leading-relaxed">{p.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
